<div class="app-container">
  <div class="sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <div class="content" id="app-content">
    <router-outlet></router-outlet>
  </div>
</div>
